'use strict';

let initializeBootstrap = require('./common/initializeBootstrap');
let formFunctions = require('./common/_form-functions');
let navigationFunction = require('./common/navigation/_index');

// Data that can be passed into your application.
let userData = {
	'username': 'TeacherMonthly1',
	'type': 'admin',
	'analyticsUrl': '#'
};

initializeBootstrap.init();
formFunctions.init();
navigationFunction.init(userData);
